export default {
  upload: {
    clickToUpload: 'Upload',
    uploadFailed: 'Oops! Upload failed. Please refresh the page and try again',
    imgLimitTips: 'Please upload jpg/png/gif images only. Images should not be larger than {imageMaxSize}MB.',
    imgTypeError: 'Please upload jpg/png/gif images only.',
    imgSizeError: 'Images should not be larger than {imageMaxSize}MB.',
    videoLimitTips: 'Please only upload mp4 video files. The file should not be larger than {imageMaxSize}MB.',
    videoTypeError: 'Please only upload mp4 video files.',
    videoSizeError: 'The file should not be larger than {imageMaxSize}MB.',
    videoDuplicate: 'Video Uploaded!',
    clickToUploadVideo: 'Upload Video',
    clickToUploadVideoCover: 'Upload Video Cover Image',
    suggestion: 'The recommended size is {size}.',
    fileTips: 'Upload files such as pdf/html/document/picture, the size should not be larger than {maxSize}MB!',
    fileTypeError: 'Please upload pdf/document/picture/html file only.',
    fileSizeError: 'File should not be larger than {maxSize}MB!'
  }
}
